<div class="modal">
  <div class="container model-container {{context?.customClass}}">
    <div class="modal-header">
      <h4 class="modal-heading">{{context?.title}}</h4>
      <img src="assets/icon/popup-close-icon.svg" *ngIf="!setDefaultRequest" (click)="closeDialog()" class="close-icon"
        width="32" height="32" alt="Close Icon">
    </div>
    <div class="modal-body" [class.more-bottom]="nonExpiredMethodsList?.length <= 0 || methodsList?.length <= 0">
      <ng-container *ngIf="nonExpiredMethodsList?.length > 0">
        <p class="smaller modal-note">{{context?.subtitle}}</p>
        <div class="list-container">
          <div class="account-address-details-container highlight-card" *ngFor="let methodItem of nonExpiredMethodsList"
            [class.not-selected]="!!displayRequiredMsg" (click)="cardSelected(methodItem)">
            <div class="custom-checkbox">
              <div class="checkbox">
                <input title="{{methodItem?.card_profile?.brand | uppercase}}" type="radio" name="shippingAddress"
                  [id]="methodItem.payment_profile_id" [value]="methodItem"
                  [checked]="selectedMethod?.payment_profile_id === methodItem.payment_profile_id">
                <label [for]="methodItem.payment_profile_id"></label>
              </div>
            </div>
            <div class="checkbox-details">
              <p class="smaller custom-checkbox-label">
                <b>{{checkBoxLabel(methodItem)}} Ending in {{methodItem?.card_profile?.last_4}}</b>
              </p>
              <p class="smallest checkbox-content">Expiry date:
                {{methodItem?.card_profile?.expiry_month}}/{{methodItem?.card_profile?.expiry_year}}</p>
            </div>
          </div>
        </div>
      </ng-container>

      <p class="smaller modal-hint">To edit your saved card(s) or add a new one, go to <a
          (click)="goToSettings()">Profile
          Settings</a></p>
      <p *ngIf="displayRequiredMsg" class="smaller modal-hint select-error">
        Select your preferred Payment Method to proceed
      </p>

      <div class="modal-actions" *ngIf="nonExpiredMethodsList?.length > 0">
        <div class="flex-actions">
          <button class="button primary" (click)="makePaymentMethodAsDefault(selectedMethod?.payment_profile_id)"
            [class.disabled]="setDefaultRequest" [disabled]="setDefaultRequest" [uiBlockButton]="setDefaultRequest">
            Save
          </button>
          <a (click)="closeDialog()">Cancel</a>
        </div>
      </div>
    </div>
  </div>
</div>